<template>
  <div class="flex-1 p-4 grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-6 self-start" style="min-width: 500px;">
    <div v-if="waiting" class="loading-mask">
      waiting...
    </div>
    <!-- 正社員の場合のみ -->
    <div class="col-span-full">
      <div class="w-auto py-0 text-sm text-right mr-3 text-indigo-800 hover:text-indigo-500 cursor-pointer" @click="openChatRoomId=true">ChatworkルームIDマスタ編集</div>

      <!-- 新卒・中途 -->
      <div class="font-bold text-xl text-gray-600 mb-3 col-span-full flex justify-between">
        新卒

        <!-- 保存済み、一次合格もしくは社員採用 -->
        <div v-if="!requestPost.declineReason&&requestPost._id"
          class="px-2 text-sm self-end border-b border-blue-700 text-blue-700 cursor-pointer"
          @click="openDecline=true">
          辞退の申し出はこちらをクリック
        </div>
      </div>

      <div v-if="requestPost.declineReason" class="border border-red-700 rounded p-2 my-3">
        <div class="text-red-700 font-bold mb-2">辞退</div>
        <div class="whitespace-pre-line">{{ requestPost.declineReason }}</div>
      </div>
    </div>

    <!-- 合否chat送信 -->
    <div v-if="requestPost.sentChat2" class="text-xs font-bold text-green-900 mb-2 col-span-full">
      <Icon iconName="CheckCircle" class="text-green-600 w-6 h-6 ml-2 inline-block" />
      採否グループチャット送信済み （送信者）{{ requestPost.sentChat2.user }} <span class="pl-5">{{ requestPost.sentChat2.date }}</span>
    </div>

    <!-- 採否 -->
    <div class="sm:col-span-full">
      <SelectionButton2
        name="acceptanceSelections"
        v-model="requestPost.interviewsResult"
        :item="acceptanceSelections"
        :multiSelect="false"
        :disabled="referenceMode||requestPost.interviewsResNotEditable||(requestPost.firstInterviewRes==='一次不合格'&&requestPost.interviewsResult&&requestPost.interviewsResult[0]=='社員不採用')"
        @change="setTitle('採否')"
      />

      <div v-if="requestPost.resultSetDate" class="mt-1 text-xs font-bold text-purple-500 w-fit ml-auto">採否決定日： {{ requestPost.resultSetDate }}</div>
    </div>

    <div class="sm:col-span-full mt-3">
      <div class="text-xs font-bold text-gray-700">
        採否決定 Chatworkメッセージ（採否決定者記入）※特筆することがあればご記入ください。
      </div>
      <div class="text-xs font-bold text-red-700">
        採用・不採用が決定している場合にこちらのメッセージが送られます。
      </div>
      <WmsTextInput
        name="interviewsDecisionChat"
        v-model="requestPost.interviewsDecisionChat"
        :multiline="true"
        :rows="getRows(requestPost.interviewsDecisionChat, 2)"
        :disabled="referenceMode"
      />
    </div>

    <div class="sm:col-span-full mt-3 flex w-full">
      <NumericTextInput2
        name="gradYear"
        caption="卒業予定年"
        v-model="requestPost.gradYear"
        :disabled="referenceMode"
        :required="true"
        :format="false"
        :error="!this.requestPost.gradYear"
        class="w-32"
        @change="setTitle()"
      />
      <div class="ml-3 self-end text-gray-700">年卒</div>

      <!-- 性別 -->
      <SelectionButton2
        name="interviewsSex"
        caption="性別（集計で必要）"
        v-model="requestPost.interviewsSex"
        :disabled="referenceMode"
        :item="sexSelections"
        :multiSelect="false"
        :required="true"
        :error="!this.requestPost.interviewsSex||!this.requestPost.interviewsSex.length"
        class="ml-6"
      />
    </div>

    <div class="sm:col-span-full mt-3">
      <WmsTextInput
        name="interviewsName"
        caption="氏名"
        v-model="requestPost.interviewsName"
        :disabled="referenceMode"
        :required="true"
        :error="!this.requestPost.interviewsName"
        @change="setTitle()"
      />
    </div>

    <div class="sm:col-span-full mt-5">
      <div class="text-xs font-bold text-gray-700 mb-1">
        添付資料（HCI・履歴書など）
      </div>

      <div class="flex">
        <div class="flex-1 mx-1">
          <WmsAttachment
            name="commonFile"
            style="max-width: none!important;"
            :value="requestPost.commonFile"
            :disabled="referenceMode"
            @change="attachmentChange('commonFile', $event)"
          />
        </div>

        <div class="flex-1 mx-1">
          <WmsAttachment
            name="commonFile2"
            style="max-width: none!important;"
            :value="requestPost.commonFile2"
            :disabled="referenceMode"
            @change="attachmentChange('commonFile2', $event)"
          />
        </div>

        <div class="flex-1 mx-1">
          <WmsAttachment
            name="commonFile3"
            style="max-width: none!important;"
            :value="requestPost.commonFile3"
            :disabled="referenceMode"
            @change="attachmentChange('commonFile3', $event)"
          />
        </div>
      </div>
    </div>

    <div class="col-span-full font-bold text-lg mt-2 flex whitespace-nowrap items-end">
      <div class="text-blue-600">
        一次面接
      </div>

      <div v-if="!referenceMode" class="text-red-700 font-bold text-base mx-auto">合否決定前は必須項目未入力でも保存可能</div>

      <div class="w-fit ml-auto mr-3">
        <select
          v-model="requestPost.firstInterviewRes"
          class="border-gray-400 rounded font-bold text-lg text-gray-600"
          :disabled="referenceMode||requestPost.interviewsResNotEditable"
          @change="setTitle('一次')"
        >
          <option v-for="(res, i) in ['', '一次合格', '一次不合格']" :value="res" :key="'r1' + i">
            {{ res }}
          </option>
        </select>
      </div>

      <div class="border border-gray-400 rounded p-2 bg-white text-gray-600">
        <span class="pr-3">合計</span>
        <span class="px-5 text-center text-blue-600 border-b border-blue-700">{{ requestPost.totalScore }}</span>
        <span class="pl-3">点 / 25点</span>
      </div>
    </div>

    <div class="sm:col-span-full border rounded border-blue-600 p-2">

      <!-- 質問 -->
      <div v-for="(row, i) in items" :key="'item'+i">
        <!-- 選択 -->
        <SelectionButton2
          v-if="row.type=='arr'&&checkShow(row.isShow)"
          :caption="row.name"
          v-model="requestPost[row.key]"
          :item="row.item"
          :multiSelect="row.multiSelect"
          :disabled="referenceMode"
          :required="checkRequire(row)"
          :error="requireValidateArr(row.key, checkRequire(row))"
          :class="row.css"
          @change="reload++"
        />

        <!-- 文字入力 -->
        <WmsTextInput
          v-if="row.type=='text'&&checkShow(row.isShow)"
          :name="row.key"
          :caption="row.name"
          v-model="requestPost[row.key]"
          :multiline="row.multiline"
          :rows="getRows(requestPost[row.key], row.num)"
          :disabled="referenceMode"
          :required="checkRequire(row)"
          :error="requireValidateText(row.key, checkRequire(row))"
          :class="row.css"
        />

        <!-- <div v-if="row.type=='line'" class="flex mt-5 font-bold text-xs text-blue-700">
          <div class="flex-1 border-t border-blue-300 self-center"></div>
          {{ row.name }}
          <div class="flex-1 border-t border-blue-300 self-center"></div>
        </div> -->

        <div v-if="row.type=='info'&&checkShow(row.isShow)">
          <div class="mt-3 text-sm">
            <div v-if="row.key=='companyInfo'">
              <div class="font-bold mt-5">面接対象者へ説明すること</div>
              <div class="pl-5">
                <p>・ 休日について（年間休日121日、年末年始、夏季休暇なし）</p>
                <p>・ 部署について（異動の可能性あり、部署によっては土曜出勤あり（日曜+他1日））</p>
                <p>・ 残業について（残業時間（2024年度平均）26.9時間、45時間は越えないように管理している）</p>
                <p>・ サポートについて（昼食代などのサポート体制）</p>
                <p>・ 評価制度について（結果以上に仕事に対してどう取り組んだかを評価している）</p>
              </div>
            </div>

            <div v-else class="pl-5 whitespace-pre-line font-bold text-blue-700">
              {{ row.text }}
            </div>
          </div>

        </div>
      </div>

      <!-- 通知設定 -->
      <div class="mt-5 border border-green-700 rounded p-2">
        <div class="text-xs font-bold text-green-700 mb-2">通知設定</div>
        <!-- 面接官 -->
        <div>
          <div class="text-xs text-gray-700 font-bold mb-1">面接官（送信元は面接官のアドレスです）<span class="ml-1 text-red-500"> * </span></div>
          <select
            v-model="requestPost.interviewerId"
            class="border-gray-300 text-sm rounded text-gray-600 py-1.5 inline"
            :class="!requestPost.interviewerId?'bg-red-200':''"
            :disabled="referenceMode"
            @change="changeInterviewer()"
          >
            <option v-for="u in userList" :value="u.userId" :key="u.userId">
              {{ u.userName }}
            </option>
          </select>
        </div>

        <!-- メールパスワード -->
        <div v-if="mailPassErr" class="mt-3 text-xs font-bold text-red-700 mb-1">{{ requestPost.interviewer }}  さんのメールパスワードを入力し保存してください</div>
        <div v-if="mailPassErr" class="flex">
          <input
            type="text"
            inputmode="latin"
            v-model="mailPass"
            class="bg-red-200 rounded border-red-300 text-sm"
            @change="changePass()"
          />
          <PrimaryButton text="メールパスワード保存" size="sm" @click="upDateMailPassByUserId()" class="ml-3">
            <!-- <LoadingIcon v-if="isSaving" slot="before" class="h-4 w-4" /> -->
          </PrimaryButton>
        </div>

        <div class="mt-3">
          <div class="block text-xs font-bold text-gray-700">新卒者メールアドレス（エナジャイザー・合否通知用）<span class="-top-0.5 ml-1 text-red-500"> * </span></div>
          <div class="flex">
            <WmsTextInput
              v-if="!referenceMode"
              name="interviewsMail"
              v-model="requestPost.interviewsMail"
              :error="!requestPost.interviewsMail"
              @change="changeMail"
            />
            <WmsSuggestInput
              v-if="!referenceMode"
              name="employmentMailDomain"
              :selectionItems="domainList"
              displayField="val"
              class="mt-auto"
              v-model="requestPost.mailDomain"
            >
            </WmsSuggestInput>
            <!-- 参照画面 -->
            <div v-else class="rounded border border-gray-300 bg-gray-200 py-1.5 px-3 mt-1 text-sm text-gray-700">
              {{ getMail() }}
            </div>

            <!-- お試し送信 -->
            <div v-if="requestPost.status!='done'" class="px-2 font-bold text-white text-sm rounded self-end">
              <PrimaryButton text="テスト送信" size="sm" class="bg-green-700" @click="testMail()">
                <Icon iconName="BadgeCheck" slot="before" class="h-4 w-4" />
              </PrimaryButton>
            </div>
          </div>
        </div>

        <!-- エージェント -->
        <div class="mt-5 text-xs font-bold text-gray-700 mb-1">エージェントへの通知設定<span class="text-blue-700 border-b border-blue-700 cursor-pointer px-1 ml-5" @click="openAgent=true">ドロップダウンに該当するものがない時はこちらをクリック</span></div>
          <select
            v-model="requestPost.agent"
            class="border-gray-400 rounded text-gray-700 text-xs"
            :disabled="referenceMode"
          >
          <option v-for="(a, i) in agentList" :value="a.userName" :key="'a' + i">
            {{ a.userName }}
          </option>
        </select>

        <!-- 通知済み -->
        <div v-if="requestPost.sentMail" class="text-xs font-bold text-green-900 mt-3">
          <Icon iconName="Mail" class="text-green-600 w-6 h-6 inline-block" />
          採否結果メール送信済み <span v-if="requestPost.sentMail.user" class="pl-1">（送信者）{{ requestPost.sentMail.user }}</span><span class="pl-3">{{ requestPost.sentMail.date }}</span>
        </div>

        <div v-if="requestPost.sentAgent" class="text-xs font-bold text-green-900 mt-3">
          <Icon iconName="Mail" class="text-green-600 w-6 h-6 inline-block" />
          エージェントへ通知済み <span v-if="requestPost.sentAgent.user" class="pl-1">（送信者）{{ requestPost.sentAgent.user }}</span><span class="pl-3">{{ requestPost.sentAgent.date }}</span>
        </div>

        <!-- 採否通知日時 -->
        <div v-else class="text-xs font-bold text-gray-700 mt-5">
          <div>採否通知日設定（面接日の翌日以降にしてください）</div>
          <div class="flex">
            <div class="self-end mb-1">採否が決定したら</div>

            <WmsDateInput
              name="sendResDate"
              v-model="requestPost.sendResDate"
              :min="requestPost.interviewsDate || today"
              class="mx-1 send-date"
              @change="reload++"
            />

            <div class="self-end mb-1">以降の9：00にメールします</div>
          </div>
        </div>

        <div class="text-xs font-bold text-green-600 mt-5">
          <p class="py-1 text-gray-500">**以下の条件が揃った場合に自動送信します**</p>
          <p>・面接官入力済み</p>
          <p>・メールアドレス入力済み</p>
          <p>・採否通知日設定済み、かつ通知日以降</p>
          <p>・採否決定済み</p>
          <p>・メール本文設定済み（採否決定時に自動設定します）</p>
          <p>・システムから一度も送信していない</p>
          <p>・メインタスク未完了</p>
        </div>
      </div>

      <div class="sm:col-span-full mt-3">
        <div class="text-xs font-bold text-gray-700">
          一次面接結果 Chatworkメッセージ（一次面接 合否の理由・その他備考）
        </div>
        <div class="text-xs font-bold text-red-700 mt-1">
          ※採用候補の場合、こちらのメッセージが送られます
        </div>
        <WmsTextInput
          name="interviewsAskChat"
          v-model="requestPost.interviewsAskChat"
          :multiline="true"
          :rows="getRows(requestPost.interviewsAskChat, 3)"
          :disabled="referenceMode"
        />
      </div>

      <div class="mt-5 text-sm rounded p-2 bg-blue-100 font-bold text-gray-700">
        <div class="text-blue-700 mb-3">評価</div>
        <div v-for="(row, i) in scores" :key="'s'+i">
          <div>（{{ i + 1 }}）{{ row.title }}</div>
          <div class="my-1 ml-5 font-normal">{{ row.text }}</div>
          <div class="flex text-white mb-3">
            <div v-for="val in [1,2,3,4,5]" :key="'ss'+val" class="flex-1 m-1 rounded cursor-pointer text-center py-1" :class="val===requestPost[row.key]?'bg-blue-700':'bg-gray-300'" @click="clickScore(row.key, val)">
              {{ val }}
            </div>
          </div>
        </div>

        <div class="flex justify-between items-end">
          <div class="flex bg-white pl-2 border border-gray-400 rounded">
            <div class="self-center text-lg mr-2 mt-0.5 text-blue-700">結果 :</div>
            <select
              v-model="requestPost.firstInterviewRes"
              class="border-0 rounded font-bold text-lg"
              :disabled="referenceMode||requestPost.interviewsResNotEditable"
              @change="setTitle('一次')"
            >
              <option v-for="(res, i) in ['', '一次合格', '一次不合格']" :value="res" :key="'r1' + i">
                {{ res }}
              </option>
            </select>
          </div>

          <div class="w-fit text-xl ml-auto border border-gray-400 rounded p-2 bg-white">
            <span class="pr-3">合計</span>
            <span class="px-5 text-2xl text-center text-blue-600 border-b border-blue-700">{{ requestPost.totalScore }}</span>
            <span class="pl-3">点 / 25点</span>
          </div>
        </div>
      </div>
    </div>

    <!-- エナジャイザー -->
    <div v-if="requestPost.firstInterviewRes=='一次合格'" class="mt-5 border border-green-600 rounded p-2 sm:col-span-full">
      <div class="cursor-pointer text-sm font-bold text-green-700">
        エナジャイザー（適性検査）
        <div class="text-gray-700 mt-2">
          <p>・不合格以外が対象です。（合否を迷った場合も受けていただく）</p>
          <p>・面接後（時間がある方には）その場ですぐに受けていただいてください。</p>
          <p>・リモート面接や自分のデバイスで受検する方には「URLを送る」ボタンを押してください。</p>
        </div>

        <div class="text-red-700 text-xs font-bold mb-1 mt-2">選択してください（メール本文に反映します）</div>
        <div class="flex text-xs font-bold flex-wrap">
          <div class="p-2 self-center mr-0.5 cursor-pointer text-white" :class="requestPost.enagizerLimit=='noLimit'?'bg-green-100 text-green-800 border border-green-700':'bg-gray-300'" @click="enagizerLimit('noLimit')">期限を設けない（この場で受検する）</div>
          <div class="p-2 self-center cursor-pointer text-white" :class="requestPost.enagizerLimit=='limit'?'bg-green-100 text-green-800 border border-green-700':'bg-gray-300'" @click="enagizerLimit('limit')">期限を設ける（この場で受検しない）</div>

          <!-- 期限有の場合は期限日を入力 -->
          <div v-if="requestPost.enagizerLimit=='limit'" class="ml-2 text-gray-700 flex">
            <div v-if="requestPost.enagizerLimit=='limit'" class="text-xs self-center">⇒ 期限日</div>
            <WmsDateInput
              name="enagizerLimitDate"
              v-model="requestPost.enagizerLimitDate"
              :min="today"
              class="ml-2"
            />
          </div>
        </div>

        <div class="flex flex-wrap">
          <PrimaryButton  v-if="requestPost.status!='done'" text="エナジャイザーURL送信" @click="openEnergizerModal()" class="bg-green-700 mt-2">
            <Icon iconName="Mail" slot="before" class="h-4 w-4" />
          </PrimaryButton>

          <!-- 送信履歴 -->
          <div v-if="requestPost.sentEnergizerUrl" class="text-xs font-bold text-green-900 ml-3 mt-2 self-center">
            <Icon iconName="Mail" class="text-green-600 w-6 h-6 ml-2 inline-block" />
              URL送信済み （送信者）{{ requestPost.sentEnergizerUrl.user }} <span class="pl-5">{{ requestPost.sentEnergizerUrl.date }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-sm font-bold text-green-700 sm:col-span-full mt-5">
      ※エナジャイザーURL送信機能・採用候補のチャット送信は「一次合格」の場合のみ可能
    </div>

    <div class="mt-3 col-span-full">
      <div v-if="requestPost.status!='done'&&(!requestPost.interviewsResult || !requestPost.interviewsResult.length)&&requestPost.firstInterviewRes=='一次合格'" class="text-red-700 text-sm font-bold">
        採用候補のチャットはエナジャイザー完了後に送ってください。サブタスクからも送信可能です。
      </div>

      <div class="flex flex-wrap">

        <!-- 未完了かつ、採否未決、かつ一次合格 -->
        <PrimaryButton v-if="requestPost.status!='done'&&(!requestPost.interviewsResult || !requestPost.interviewsResult.length)&&requestPost.firstInterviewRes=='一次合格'" text="大野さんへ採用候補チャット送信" @click="interviewsSendChat()" class="mt-1 bg-green-700">
          <Icon iconName="UserAdd" slot="before" class="h-5 w-5" />
        </PrimaryButton>

        <!-- 一次面接chat送信 -->
        <div v-if="requestPost.sentChat" class="text-xs font-bold text-green-900 ml-3 mt-2 self-center">
          <Icon iconName="CheckCircle" class="text-green-600 w-6 h-6 ml-2 inline-block" />
          採用候補チャット送信済み （送信者）{{ requestPost.sentChat.user }} <span class="pl-5">{{ requestPost.sentChat.date }}</span>
        </div>
      </div>
    </div>

    <!-- 通知内容 -->
    <div ref="sendMail" v-if="requestPost.interviewsResult&&requestPost.interviewsResult.length" class="sm:col-span-full mt-3 border border-yellow-700 rounded bg-yellow-50 p-2">
      <div class="font-bold text-yellow-700 flex">採否通知メール<div class="ml-auto text-xs cursor-pointer font-normal border-b border-yellow-700 self-end" @click="setMail()">初期値セット</div></div>

      <div v-if="requestPost.sentMail" class="text-xs font-bold text-green-900 mt-3">
        <Icon iconName="Mail" class="text-green-600 w-6 h-6 ml-2 inline-block" />
        採否結果メール送信済み <span v-if="requestPost.sentMail.user" class="pl-1">（送信者）{{ requestPost.sentMail.user }}</span><span class="pl-3">{{ requestPost.sentMail.date }}</span>
      </div>

      <div v-if="requestPost.sentAgent" class="text-xs font-bold text-green-900 mt-3">
        <Icon iconName="Mail" class="text-green-600 w-6 h-6 ml-2 inline-block" />
        エージェントへ通知済み <span v-if="requestPost.sentAgent.user" class="pl-1">（送信者）{{ requestPost.sentAgent.user }}</span><span class="pl-3">{{ requestPost.sentAgent.date }}</span>
      </div>

      <div class="mt-3">
        <div v-if="requestPost.sendResDate">
          <div v-if="!requestPost.sentMail" class="text-yellow-700 font-bold">・採否決定後、{{ requestPost.sendResDate }} 以降の9：00に自動で送信します。</div>
          <div v-if="requestPost.agent&&!requestPost.sentMail" class="text-yellow-700 font-bold mt-2">・エージェントにも自動で送信します。（下記とは別の文章）</div>
          <!-- 設定日以降、保存済みで未完了、採否決定更新後 -->
          <PrimaryButton v-if="requestPost.sendResDate<=today&&requestPost.status=='open'&&requestPost.interviewsResNotEditable" :text="requestPost.sentMail?'再度送信する':'今すぐメール送信する'" @click="sendMail()" class="m-3 bg-yellow-700">
            <Icon iconName="Mail" slot="before" class="h-4 w-4" />
          </PrimaryButton>
        </div>
      </div>

      <WmsTextInput
        name="subject"
        caption="件名"
        v-model="requestPost.mailSubject"
        :disabled="requestPost.status=='done'"
        class="mt-3"
      />

      <div class="text-gray-700 font-bold text-xs mt-3 mb-1">本文</div>
      <textarea
        :rows="10"
        v-model="requestPost.mailText"
        :disabled="requestPost.status=='done'"
        class="border-gray-300 rounded w-full text-xs mb-3"
        :class="(requestPost.status=='done')?'cursor-not-allowed bg-gray-200':''"
      ></textarea>
    </div>
    <div v-else class="text-sm font-bold text-yellow-700 sm:col-span-full mt-5">
      ※採否結果メール本文は「採否決定後」に表示
    </div>

    <div class="text-transparent">{{reload}}</div>

    <!-- 社員専用チャットワークルームIDモーダル -->
    <InterviewsChatRoomIdModal
      v-model="openChatRoomId"
      :open="openChatRoomId"
      :type="3"
      @close="closeChatRoomIdModal()"
    />

    <!-- エージェント -->
    <InterviewsAgentChatRoomIdModal
      v-model="openAgent"
      :open="openAgent"
      @getAgentList="getAgentList"
      @close="openAgent=false"
    />

    <!-- エナジャイザー送信 -->
    <InterviewsEnegizerSendModal
      v-model="openEnergizer"
      :open="openEnergizer"
      :name="requestPost.interviewsName"
      :to="mailTo"
      :isLimit="requestPost.enagizerLimit"
      :limitDate="requestPost.enagizerLimitDate"
      :user="requestPost.interviewer"
      :userId="requestPost.interviewerId"
      :newGrad="true"
      @sentEnergizer="sentEnergizer"
      @close="openEnergizer=false"
    />

    <!-- 辞退 -->
    <InterviewsDeclineModal
      v-model="openDecline"
      :open="openDecline"
      :id="requestPost._id"
      :requestNo="requestPost.requestNo"
      :status="requestPost.status"
      :name="requestPost.interviewsName"
      @saveReason="saveReason"
      @close="openDecline=false"
    />
  </div>
</template>

<script>
  import Icon from '@components/Icon.vue'
  import PrimaryButton from '@components/PrimaryButton.vue'
  import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
  import NumericTextInput2 from '@components/NumericTextInput2.vue'
  import SelectionButton2 from '@components/SelectionButton2.vue'
  import WmsAttachment from '@wmscomponents/WmsAttachment.vue'
  import InterviewsChatRoomIdModal from './InterviewsChatRoomIdModal.vue'
  import InterviewsEnegizerSendModal from './InterviewsEnegizerSendModal.vue'
  import InterviewsDeclineModal from './InterviewsDeclineModal.vue'
  import InterviewsAgentChatRoomIdModal from './InterviewsAgentChatRoomIdModal.vue'
  import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
  import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
  import * as requestPostManager from '@managers/requestPostManager'
  import * as constants from '@libs/constants'
  import * as chatwork from '@libs/chatwork'
  import * as dialogs from '@libs/dialogs'
  import * as helper from '@libs/helper'
  import * as utils from '@libs/utils'
  import * as moment from 'moment'
  import * as backend from '@libs/backend'
  import { OHNO_USER_ID } from '@/config'


  const SEX_SELECTIONS = [
    {
      value: '男性',
      text: '男性'
    },
    {
      value: '女性',
      text: '女性'
    }
  ]

  const ACCEPTANCE_SELECTIONS = [
    {
      value: '社員採用',
      text: '社員採用'
    },
    {
      value: '社員不採用',
      text: '社員不採用'
    }
  ]

  const LIVING_ELECTIONS = [
    {
      value: '1人暮らし',
      text: '1人暮らし'
    },
    {
      value: '実家',
      text: '実家'
    },
    {
      value: 'その他',
      text: 'その他'
    }
  ]

  const LIVING_ELECTIONS2 = [
    {
      value: '近い',
      text: '近い'
    },
    {
      value: '遠方（片道 ドアtoドアで1時間半以上）',
      text: '遠方（片道 ドアtoドアで1時間半以上）'
    },
    {
      value: 'その他',
      text: 'その他'
    }
  ]

  const LIVING_ELECTIONS3 = [
    {
      value: '1人暮らし可能',
      text: '1人暮らし可能'
    },
    {
      value: '1人暮らし不可能',
      text: '1人暮らし不可能'
    },
    {
      value: 'その他',
      text: 'その他'
    }
  ]

  const FLG_SELECTIONS = [
    {
      value: 'あり',
      text: 'あり'
    },
    {
      value: 'なし',
      text: 'なし'
    }
  ]

  const LICENSE_SELECTIONS = [
    {
      value: '車の免許あり',
      text: '車の免許あり'
    },
    {
      value: 'なし',
      text: 'なし'
    }
  ]

  const TOBACCO_SELECTIONS = [
    {
      value: '喫煙者',
      text: '喫煙者'
    },
    {
      value: '非喫煙者',
      text: '非喫煙者'
    }
  ]

  const SOCIAL_SELECTIONS = [
    {
      value: '意欲的',
      text: '意欲的'
    },
    {
      value: '消極的',
      text: '消極的'
    }
  ]

  export default {
    components: {
      Icon,
      PrimaryButton,
      WmsTextInput,
      NumericTextInput2,
      SelectionButton2,
      WmsAttachment,
      InterviewsChatRoomIdModal,
      WmsSuggestInput,
      WmsDateInput,
      InterviewsEnegizerSendModal,
      InterviewsDeclineModal,
      InterviewsAgentChatRoomIdModal
    },

    props: {
      requestPost: {
        type: Object,
        default: () => {}
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      from: {
        type: String,
        default: 'main'
      },
      referenceMode: {
        type: Boolean,
        default: false
      },
      departmentLists: {
        type: Array
      },
      mainValidation: {
        type: Function
      }
    },

    data() {
      return {
        reload: 0,
        waiting: false,
        today: moment().format('YYYY-MM-DD'),
        items: [
            { key: 'interviewsDepartmentId', name: '希望部署（Chatwork送信先）', type: 'arr', require: true, css: 'five-selection mt-5', item: utils.desiredDepartment(this.departmentLists), multiSelect: false }
          , { key: 'interviewsDepartmentMemo', name: '希望部署に関する備考', type: 'text', require: false, css: 'mt-3', multiline: true, num: 1 }
          , { key: 'reason', name: '当社を志望した理由', type: 'text', require: true, css: 'mt-5', multiline: true, num: 3 }
          , { key: 'hpComment', name: 'HPの感想（何か思ったことがあれば）', type: 'text', require: true, css: 'mt-3', multiline: true, num: 3 }

          , { key: 'otherOffer', name: '他社内定の有無', type: 'arr', require: true, css: 'mt-5', item: FLG_SELECTIONS, multiSelect: false }
          , { key: 'otherOffer2', name: '他社内定「あり」の場合、その業界・職種について', type: 'text', checkRequire: ['otherOffer', 'あり'], css: 'mt-3', multiline: true, num: 3 }
          , { key: 'otherOffer3', name: '他社選考中の企業数、その業界・職種について', type: 'text', require: true, css: 'mt-3', multiline: true, num: 3 }



          , { key: 'studentLearn', name: '学生時代に学んだこと', type: 'text', require: true, css: 'mt-5', multiline: true, num: 3 }
          , { key: 'club', name: '部活で得た成果（入っていない場合は、未所属と記入）', type: 'text', require: true, css: 'mt-5', multiline: true, num: 3 }

          , { key: 'partTimeJob', name: 'アルバイト経験（勤務先・仕事内容・期間）', type: 'text', require: true, css: 'mt-5', multiline: true, num: 3 }
          , { key: 'studentPR', name: '学生時代に頑張ったこと', type: 'text', require: true, css: 'mt-5', multiline: true, num: 3 }
          , { key: 'studentStrength', name: '学生時代に誰にも負けないと思うこと', type: 'text', require: true, css: 'mt-5', multiline: true, num: 3 }
          , { key: 'pastFailure', name: '失敗経験', type: 'text', require: true, css: 'mt-5', multiline: true, num: 3 }
          , { key: 'strength', name: '長所', type: 'text', require: true, css: 'mt-5', multiline: true, num: 3 }
          , { key: 'weakness', name: '短所', type: 'text', require: true, css: 'mt-5', multiline: true, num: 3 }

          , { type: 'info', key: 'companyInfo' }

          , { key: 'interviewsLiving', name: '現在の住まい', type: 'arr', require: true, css: 'mt-5', item: LIVING_ELECTIONS, multiSelect: false }
          , { key: 'interviewsLiving2', name: '実家の場合', type: 'arr', require: true, css: 'mt-3', item: LIVING_ELECTIONS2, multiSelect: false, isShow: ['interviewsLiving', '実家'] }
          , { key: 'interviewsLiving3', name: '実家が遠方の場合', type: 'arr', require: true, css: 'mt-3', item: LIVING_ELECTIONS3, multiSelect: false, isShow: ['interviewsLiving2', '遠方（片道 ドアtoドアで1時間半以上）'] }
          , { key: 'interviewsLiving4', name: '住まい関する備考', type: 'text', require: false, css: 'mt-3', multiline: true, num: 1 }

          , { key: 'interviewsTobacco', name: '喫煙', type: 'arr', require: true, css: 'mt-5', item: TOBACCO_SELECTIONS, multiSelect: false }
          , { type: 'info', isShow: ['interviewsTobacco', '喫煙者'], text: '※禁煙手当があることを説明してください。' }

          , { key: 'companySocial', name: '懇親会（年数回会社主催の自由参加）', type: 'arr', require: true, css: 'mt-5', item: SOCIAL_SELECTIONS, multiSelect: false }
          , { key: 'companySocial2', name: '懇親会に関する備考', type: 'text', require: false, css: 'mt-3', multiline: true, num: 1 }

          , { key: 'interviewsLicense', name: '運転免許', type: 'arr', require: true, css: 'mt-5', item: LICENSE_SELECTIONS, multiSelect: false }
          , { key: 'interviewsLicense2', name: '運転する頻度', type: 'text', checkRequire: ['interviewsLicense', '車の免許あり'], css: 'mt-3', multiline: true, num: 3 }

          , { key: 'vision', name: '入社後のビジョン（職種内容の理解度、計画性を確認をしてください）', type: 'text', require: true, css: 'mt-3', multiline: true, num: 3 }
          , { key: 'deal', name: '断りにくい依頼への対応（反応を確認してください）', type: 'text', require: true, css: 'mt-3', multiline: true, num: 3 }
        ],
        acceptanceSelections: ACCEPTANCE_SELECTIONS,
        sexSelections: SEX_SELECTIONS,
        domainList: constants.DOMAIN_SELECTIONS,
        scores: [
          { key: 'firstImpression', title: '第一印象', text: '挨拶・声・元気・表情・明るさ・身だしなみ' },
          { key: 'motivationLevel', title: '志望度', text: '会社研究・仕事の理解度・熱意' },
          { key: 'ambition', title: '向上心', text: '自発的取り組み・失敗や挫折の経験' },
          { key: 'actionTaking', title: '実行力', text: '成功体験・行動・チーム活動' },
          { key: 'honesty', title: '素直さ', text: '受け答え（一貫性）・夢・目標' },
        ],

        // 面接官リスト
        userList: [],
        // メールパス
        mailPass: null,
        mailPassErr: false,
        // エージェント
        agentList: [],
        openAgent: false,
        // エナジャイザー
        openEnergizer: false,
        mailTo: '',

        // チャットワークルームIDマスタモーダルopen
        openChatRoomId: false,

        // 辞退
        openDecline: false
      }
    },

    computed: {
      /**
       * 行数をカウント
       */
      getRows() {
        return (val, num)=> {
          if (val) {
            const arr = val.split('\n')
            let rows = arr.length
            arr.forEach((a) => {
              if (a.length >= 77) {
                rows += Math.floor(a.length / 77)
              }
            })
            if (rows < num) {
              rows = num - 1
            }
            return rows + 1
          } else {
            return num
          }
        }
      },
    },

    async created() {
        // 面接官候補取得
        const res = await backend.searchData('user/getByAuth', { auth: 'regular_staff' })
        if (res.data.data) {
          this.userList = res.data.data
        }
        // エージェント候補取得
        this.getAgentList()
      if (!this.requestPost.interviewer) {
        this.changeInterviewer()
      }
    },

    methods: {
      /**
      * 添付ファイル
      */
      attachmentChange(targetAttachmentName, attachmentInfo) {
        if (!this.requestPost[targetAttachmentName]) {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
        if (attachmentInfo) {
          this.requestPost[targetAttachmentName].originalName = attachmentInfo.filename
          this.requestPost[targetAttachmentName].content = attachmentInfo.content
        } else {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
      },

      /**
      * 必須項目入力チェック
      */
      async validation() {
        // 卒業予定年、氏名、性別
        if (!this.requestPost.gradYear) {
          await dialogs.showErrorDialog('卒業予定年', '入力してください。')
          return false
        }
        if (!this.requestPost.interviewsName) {
          await dialogs.showErrorDialog('氏名', '入力してください。')
          return false
        }
        if (!this.requestPost.interviewsSex || !this.requestPost.interviewsSex.length) {
          await dialogs.showErrorDialog('性別', '集計で使用します。性別を選択してください。')
          return false
        }
        if (!this.requestPost.interviewerId) {
          await dialogs.showErrorDialog('面接官', 'メール送信で使用します。面接官を選択してください。')
          return false
        }
        if (!this.requestPost.interviewsMail) {
          await dialogs.showErrorDialog('新卒者メールアドレス', '新卒者メールアドレスを入力してください。')
          return false
        }

        // 合否決定
        if (this.requestPost.firstInterviewRes) {
          for (let i = 0; i < this.items.length; i++) {
            const row = this.items[i]
            if (row.require || row.checkRequire) {
              // 非表示の場合はスキップ
              if (row.isShow && !this.isShow(row.isShow[0], row.isShow[1])) {
                continue
              }

              // 必須項目でない場合はスキップ
              if (row.checkRequire && !this.isShow(row.checkRequire[0], row.checkRequire[1])) {
                continue
              }

              if (row.type == 'arr') {
                if (this.requireValidateArr(row.key, true)) {
                  await dialogs.showErrorDialog(row.name, '選択してください。')
                  return false
                }
              } else if (row.type == 'text') {
                if (this.requireValidateText(row.key, true)) {
                  await dialogs.showErrorDialog(row.name, '入力してください。')
                  return false
                }
              }
            }
          }

          // 評価点
          for (let i = 0; i < this.scores.length; i++) {
            const s = this.scores[i]
            if (!this.requestPost[s.key]) {
              await dialogs.showErrorDialog('評価点 未選択', s.title + ' の点数を選択してください。')
              return false
            }
          }
        }
        return true
      },

      /**
        * 社員面接用ChatworkルームIDモダール閉じる
        */
      closeChatRoomIdModal() {
        this.openChatRoomId = false
      },

      /**
      * タイトルをセット
      */
      async setTitle(type) {
        // 採否結果＋名前
        const val = {
          interviewsResult: this.requestPost.interviewsResult,
          name: this.requestPost.interviewsName,
          newGrad: true,
          firstInterviewRes: this.requestPost.firstInterviewRes,
          year: this.requestPost.gradYear
        }
        this.$emit('get-title', val)

        if (type === '一次') {
          if (this.requestPost.firstInterviewRes === '一次不合格') {
            this.requestPost.interviewsResult = ['社員不採用']
            await dialogs.showInfoDialog('不合格のため不採用にします', '一次面接が不合格の場合、強制的に「不採用」となります。')
            this.reload++

          // まだ決定ではない場合
          } else if (!this.requestPost.interviewsResNotEditable) {
            this.requestPost.interviewsResult = []
          }

          this.setMail()
        } else if (type === '採否') {
          this.setMail()
        }
      },

      /**
       * 項目表示非表示確認
       * @param val 対象項目の表示有無
       */
      checkShow(val) {
        if (val) {
          return this.isShow(val[0], val[1])
        }
        return true
      },

      /**
       * key項目（配列）にvalが含まれているか
       * @param key 項目名（配列）
       * @param val 値
       */
      isShow(key, val) {
        if (this.requestPost[key] && this.requestPost[key].includes(val)) {
          return true
        }
        return false
      },

      /**
       * 必須判定
       */
      checkRequire(row) {
        if (row.require) {
          return true
        }
        if (row.checkRequire) {
          return this.isShow(row.checkRequire[0], row.checkRequire[1])
        }
        return false
      },

      /**
       * 必須項目入力チェック（文字列）
       */
      requireValidateText(item, req) {
        if (req && !this.requestPost[item]) {
          return true
        }
        return false
      },

      /**
       * 必須項目入力チェック（配列）
       */
      requireValidateArr(item, req) {
        if (req && (!this.requestPost[item] || !this.requestPost[item].length)) {
          return true
        }
        return false
      },

      /**
       * 評価点クリックイベント
       * @param key プロパティー名
       * @param val 点数
       */
      clickScore(key, val) {
        this.requestPost[key] = val
        this.calcPoint()
      },

      /**
       * 評価点合計点計算
       */
      calcPoint() {
        let res = 0
        this.scores.forEach((row) => {
          if (this.requestPost[row.key]) {
            res += this.requestPost[row.key]
          }
        })
        this.requestPost.totalScore = res
        this.reload++
      },

      /**
      * チャット送信
      */
      async interviewsSendChat() {
        let result = {}

        // 参照モード（サブタスク）ではなく、採否未決定の場合
        if (!this.referenceMode && (!this.requestPost.interviewsResult || !this.requestPost.interviewsResult.length)) {
          if (!await this.mainValidation()) {
            return false
          }
          if (!await this.validation()) {
            return
          }
          // 更新
          if (this.requestPost.requestNo && this.requestPost._id) {
            result = await requestPostManager.update(this, this.requestPost)
          // 新規
          } else {
            result = await requestPostManager.register(this, this.requestPost)
            this.requestPost._id = result.id
            this.requestPost.requestNo = result.requestNo
          }
        }

        const requestPostId = this.requestPost._id || result.id
        const requestNo = this.requestPost.requestNo || result.requestNo

        // 一次面接の結果が決まっており、採否が決まっていない場合
        if (this.requestPost.firstInterviewRes && (!this.requestPost.interviewsResult || !this.requestPost.interviewsResult.length)) {
          // 合格の場合に限る（大野様より採用候補しか通知は欲しくない）
          if (this.requestPost.firstInterviewRes == '一次不合格') return

          // URL
          const url = `${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}RequestPost?requestPostId=${requestPostId}&mode=1`

          // メッセージ
          let text = `（新卒）${this.requestPost.gradYear}年卒`
          text += `\r\n■ 氏名 ： ${this.requestPost.interviewsName}（${this.requestPost.interviewsSex}）\r\n`

          // 評価点
          for (let i = 0; i < this.scores.length; i++) {
            const s = this.scores[i]
            text += `\r\n${s.title} ： ${this.requestPost[s.key]} 点`
          }

          text += `\r\n【合計  ${this.requestPost.totalScore} 点】\r\n`

          for (let i = 0; i < this.items.length; i++) {
            const row = this.items[i]
            // 必須項目
            if (row.require || (row.checkRequire && this.isShow(row.checkRequire[0], row.checkRequire[1]))) {
              // 非表示になっているものはスキップ
              if (row.isShow && !this.isShow(row.isShow[0], row.isShow[1])) {
                continue
              }
              // 部署の場合
              if (row.key == 'interviewsDepartmentId') {
                if (this.departmentLists && this.departmentLists.length) {
                  const depselect = this.departmentLists.find((d) => {
                    return this.requestPost.interviewsDepartmentId[0] == d.departmentId
                  })
                  if (depselect && depselect.departmentId) {
                    text += `\r\n■ 希望部署 ： ${depselect.name}`
                  }
                }
              } else {
                // カッコがある場合、カッコの中は取得しない
                if (row.name && row.name.indexOf('（') > -1) {
                  text += `\r\n■ ${row.name.replace(/（.*?）/g, '').replace('\r\n', '')} ： `
                } else {
                  text += `\r\n■ ${row.name} ： `
                }

                // 配列の場合
                if (row.type == 'arr' && this.requestPost[row.key]) {
                  if (row.multiSelect) {
                    text += this.requestPost[row.key].join('・')
                  } else {
                    text += this.requestPost[row.key][0]
                  }

                // 文字列の場合
                } else if (row.type == 'text') {
                  text += this.requestPost[row.key]
                }
              }
            }
          }

          if (this.requestPost.interviewsAskChat) {
            text += '\r\n\r\n-------------------面接官より-------------------\r\n' + this.requestPost.interviewsAskChat
          }

          // 送信内容
          const msg = text + '\r\n\r\n●送信者：' + this.$store.getters.user.user_name + '\r\n●メインタスク：' + url
          // 添付資料
          let isFile = ''
          if (this.requestPost.commonFile.originalName || this.requestPost.commonFile2.originalName || this.requestPost.commonFile3.originalName) {
            isFile = '\r\n（添付資料も送信します。）'
          }

          const res = await dialogs.showConfirmDialog('大野さんに採用候補のチャット送信しますか？', msg + isFile)
          // 送信する場合
          if (res == 'YES') {

            // 送信先ルームIDを取得
            const chat = await requestPostManager.searchInterviewsChatRoomID(this, { category: '採用候補', departmentId: this.requestPost.interviewsDepartmentId[0], newGrad: true, gradYear: this.requestPost.gradYear })

            // 大野様のアカウントIDを取得
            const accountId = utils.getChatworkAccountId(6244, this.$store.getters.userList)

            if (!chat || !chat.roomId || !chat.apiToken) {
              await dialogs.showErrorDialog('送信できませんでした。', '「採用候補」チャットワーク情報が登録されていませんでした。\r\n※右上の『ChatworkルームIDマスタ編集』をクリックしてください。')
              return false
            }

            let to = '[To:]'
            if (accountId) {
              to = `[To:${accountId}]`
            }
            to += '大野 大 さん'

            const message =
              to
              + '[info][title]【新卒】社員の採用候補[/title]'
              + msg
              + '[/info]'

            try {
              await chatwork.sendChatWorkMssage(
                chat.roomId,
                message,
                chat.apiToken
              )

              // 添付資料（HCI・履歴書）をチャットで送信
              let fileText = `● ${this.requestPost.interviewsName}さんのHCI・履歴書`
              await chatwork.uploadFileAttachments(chat.roomId, chat.apiToken, fileText, [this.requestPost.commonFile, this.requestPost.commonFile2, this.requestPost.commonFile3])

              // 採用候補フラグON
              const isCandidate = true
              // チャット送信履歴
              const sentChat = { user: utils.deleteKana(this.$store.getters.user.user_name), date: moment().format('YYYY-MM-DD HH:mm'), res: '一次合格' }

              // 即反映
              this.requestPost.isCandidate = isCandidate
              this.requestPost.sentChat = sentChat
              this.reload++

              await requestPostManager.upDateOneForInterviews(this, this.requestPost.requestNo, { isCandidate, sentChat })

              if (this.referenceMode) {
                await dialogs.showSuccessDialog('採用候補チャット送信', '採用候補チャットを送信しました。')
                this.$emit('saveSubTask')
              } else {
                this.$emit('storeOriginal')
                await dialogs.showSuccessDialog('採用候補チャット送信・メインタスク保存', '採用候補チャットを送信しました。また、メインタスクも保存しました。')
                // 初期サブを完了にする
                this.$emit('upDateInterviewsSubTaskInit', null, true, true)
              }
              this.reload++

            } catch (error) {
              alert('チャットワーク送信失敗\r\n対象のRoomにPigeonのアカウントを追加しているかご確認ください。')
              return false
            }
          }

        // 社員の面接関連で採否決定の場合
        } else if (this.requestPost.interviewsResult && this.requestPost.interviewsResult.length && (!this.requestPost.sentChat2 || this.requestPost.sentChat2.res != this.requestPost.interviewsResult[0])) {
          // サブタスク自動登録
          this.$emit('saveInterviewsSubTask', requestPostId, requestNo)
          // 採否
          const ir = this.requestPost.interviewsResult[0].replace('社員', '')
          // メインURL
          const url1 = `${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}RequestPost?requestPostId=${requestPostId}&mode=1`
          // サブタスクURL
          const url2 = `${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}taskRequest?requestPostId=${requestPostId}`
          // メッセージ
          let text = `（新卒）${this.requestPost.gradYear}年卒予定 の ${this.requestPost.interviewsName}さんは「${ir}」となりました。`
          // 採否決定 Chatworkメッセが記入されている場合
          if (this.requestPost.interviewsDecisionChat) {
            text += '\r\n\r\n' + this.requestPost.interviewsDecisionChat
          }
          // メール送信設定
          if (this.requestPost.sendResDate && this.requestPost.mailText && !this.requestPost.sentMail && this.requestPost.interviewerId && this.requestPost.interviewsMail) {
            let day = this.requestPost.sendResDate

            // 設定日が今日もしくは前
            if (this.requestPost.sendResDate <= this.today) {
              const time = moment().format('HH:mm')
              // 今、9時前
              if ('09:00' > time) {
                day = '本日'
              } else {
                day = '明日'
              }
            }
            text += '\r\n\r\n※採否連絡メールが' + day +  ' 9:00 に自動送信されます。'
          }
          // 送信内容
          const msg = text + '\r\n\r\n●送信者：' + this.$store.getters.user.user_name + '\r\n●メインタスク：' + url1 + '\r\n●サブタスク：' + url2

          let res = 'YES'

          // 大野様が採否決定
          if (String(this.$store.getters.user.id) == String(OHNO_USER_ID)) {
            // 既に送信済み
            if (this.requestPost.sentChat2) {
              res = 'NO'
            }
          } else {
            // 大野様以外の人は確認する
            res = await dialogs.showConfirmDialog(ir + '決定のチャット送信しますか？', msg, '送信する', '今は送信しない')
          }

          // 送信する場合
          if (res == 'YES') {
            // 送信先ルームIDを取得
            const chat = await requestPostManager.searchInterviewsChatRoomID(this, { category: ir, departmentId: this.requestPost.interviewsDepartmentId[0], newGrad: true, gradYear: this.requestPost.gradYear })

            // 面接官のアカウントIDを取得
            const accountId = utils.getChatworkAccountIdByName(this.requestPost.interviewer, this.$store.getters.userList)

            if (!chat || !chat.roomId || !chat.apiToken) {
              await dialogs.showErrorDialog('送信できませんでした。', '「' + ir + '」チャットワーク情報が登録されていませんでした。\r\n※右上の『ChatworkルームIDマスタ編集』をクリックしてください。')
              return false
            }

            let to = '[To:]'
            if (accountId) {
              to = `[To:${accountId}]`
            }
            to += this.requestPost.interviewer + 'さん'

            const message =
              to
              + '[info][title]【新卒】社員の採否決定[/title]'
              + msg
              + '[/info]'

            try {
              await chatwork.sendChatWorkMssage(
                chat.roomId,
                message,
                chat.apiToken
              )

              // チャット送信履歴
              const sentChat2 = { user: utils.deleteKana(this.$store.getters.user.user_name), date: moment().format('YYYY-MM-DD HH:mm'), res: this.requestPost.interviewsResult[0] }
              await requestPostManager.upDateOneForInterviews(this, this.requestPost.requestNo, { sentChat2 })

              // 大野様が採否決定したら
              if (String(this.$store.getters.user.id) == String(OHNO_USER_ID)) {
                // 勝手に送ったのでダイアログだす
                await dialogs.showSuccessDialog('採否決定チャット送信完了', '採否が決まったことを担当者に送信しました。')
              }
            } catch (error) {
              alert('チャットワーク送信失敗\r\n対象のRoomにPigeonのアカウントを追加しているかご確認ください。')
              return false
            }
          }
        }
        return true
      },

      /**
       * 面接官変更
       */
      changeInterviewer() {
        if (this.requestPost.interviewerId) {
          const res = this.userList.find((u) => {
            return u.userId == this.requestPost.interviewerId
          })

          if (res && res.userId) {
            this.requestPost.interviewer = res.userName
          } else {
            this.requestPost.interviewer = ''
          }
        }
      },

      /**
       * メールパスワード更新
       */
      async upDateMailPassByUserId() {
        if (!this.requestPost.interviewerId) {
          await dialogs.showErrorDialog('面接官を選択してください', 'メールパスワードは面接官のメールパスワードになるのでご注意ください。')
          return
        }
        if (!this.mailPass) {
          await dialogs.showErrorDialog('メールパスワード未入力', '保存するメールパスワードを入力してください。')
          return
        }
        await backend.postData('user/upDateMailPassByUserId', { mailPass: this.mailPass, userId: this.requestPost.interviewerId })
        await dialogs.showSuccessDialog('メールパスワード保存完了', this.requestPost.interviewer + '　さんのメールパスワードを保存しました。')
        this.mailPassErr = false
      },

      /**
       * メールパスワード変更
       */
      changePass() {
        this.mailPass = utils.hankaku(this.mailPass)
      },

      /**
       * エナジャイザー期限ありなし
       */
      enagizerLimit(val) {
        this.requestPost.enagizerLimit = val
        this.reload++
      },

      /**
       * メールテスト送信
       */
      async testMail() {
        if (!this.requestPost.interviewsMail) {
          await dialogs.showErrorDialog('メールアドレス未入力', 'メールアドレスを入力してください。')
          return
        }
        if (!this.requestPost.interviewerId) {
          await dialogs.showErrorDialog('面接官 未選択', '送信元は面接官のメールアドレスです。面接官を選択してください。※面接権限を持っている人に限ります。')
          return
        }

        const log = await dialogs.showConfirmDialog('メールアドレス確認用の送信をしますか？', 'メールアドレスが正しいかテスト送信を行います。よろしいですか？')
        if (log != 'YES') {
          return
        }
        this.waiting = true

        try {
          this.mailPassErr = false

          const param = {
            to: this.getMail(),
            newGrad: true,
            interviewerId: this.requestPost.interviewerId,
            interviewer:  this.requestPost.interviewer,
            name: this.requestPost.interviewsName
          }

          const res = await backend.postData('apiProxy/mailApi/interviewsTest', param)
          if (res.data && res.data.data == 'success') {
            await dialogs.showSuccessDialog('テスト送信しました', '本人にメールが届いたかご確認ください。\r\n届いていない場合はメールアドレスが間違っている可能性があります。')
          } else {
            let err = ''
            if (res.data && res.data.data) {
              err = 'エラー詳細：' + res.data.data
            }

            await dialogs.showErrorDialog('テスト送信失敗', err)

            if (err.indexOf('パスワード') > -1) {
              this.mailPassErr = true
            }
          }
        } finally {
          this.waiting = false
        }
      },

      /**
       * 送信先メアド
       */
      getMail() {
        let to = this.requestPost.interviewsMail
        if (this.requestPost.mailDomain) {
          to += this.requestPost.mailDomain
        }
        return to
      },

      /**
       * エナジャイザー送信モーダルopen
       */
      async openEnergizerModal() {
        if (!this.requestPost.requestNo || !this.requestPost._id) {
          await dialogs.showErrorDialog('一度保存してください', '保存（仮登録でもOK）してください。')
          return
        }
        if (!this.requestPost.interviewsMail) {
          await dialogs.showErrorDialog('メールアドレス未入力', 'メールアドレスを入力してください。')
          return
        }
        if (!this.requestPost.interviewerId) {
          await dialogs.showErrorDialog('面接官 未選択', '送信元は面接官のメールアドレスです。面接官を選択してください。※面接権限を持っている人に限ります。')
          return
        }
        if (!this.requestPost.enagizerLimit) {
          await dialogs.showErrorDialog('エナジャイザーの期限の有無を選択してください', '送信内容に反映するのでエナジャイザーの期限の有無を選択してください。')
          return
        }
        if (this.requestPost.enagizerLimit == 'limit' && !this.requestPost.enagizerLimitDate) {
          await dialogs.showErrorDialog('エナジャイザーの期限日を入力してください', '送信内容に反映するのでエナジャイザーの期限日を入力してください。')
          return
        }
        if (this.requestPost.enagizerLimit == 'limit') {
          if (this.today > this.requestPost.enagizerLimitDate) {
            await dialogs.showErrorDialog('エナジャイザーの期限日を変更してください', '期限日が過去になっています。')
            return
          }
        }
        this.mailTo = this.getMail()
        this.openEnergizer = true
      },

      /**
       * エナジャイザー送信記録
       */
      async sentEnergizer() {
        const sentEnergizerUrl = { user: utils.deleteKana(this.$store.getters.user.user_name), date: moment().format('YYYY-MM-DD HH:mm') }
        this.requestPost.sentEnergizerUrl = sentEnergizerUrl
        this.reload++

        // 参照画面
        if (this.referenceMode) {
          await requestPostManager.upDateOneForInterviews(this, this.requestPost.requestNo, { sentEnergizerUrl })
        } else if (this.requestPost.requestNo) {
          // 更新
          await requestPostManager.update(this, this.requestPost)
        }
      },

      /**
       * 合否通知を今すぐ
       */
      async sendMail() {
        if (!this.requestPost.mailSubject || !this.requestPost.mailText) {
          await dialogs.showErrorDialog('メールのタイトル・本文 未完成', 'メールのタイトル、本文が未完成なので送信できません。')
          return
        }
        let log
        // 参照画面ではない場合
        if (!this.referenceMode) {
          if (!await this.validation()) return

          if (this.requestPost.agent) {
            log = await dialogs.showConfirmDialog3('採否通知先を選択してください', '送信前に今のデータを保存します。', 'エージェントのみ', '新卒者のみ', '両方')
          } else {
            log = await dialogs.showConfirmDialog('新卒者へ採否メール送信しますか？', '今すぐ採否メールを送信してよろしいでしょうか？\r\nまた、送信前に今のデータを保存します。')
            if (log != 'YES') {
              return
            }
            log = '2'
          }

          let result
          // 更新
          if (this.requestPost.requestNo && this.requestPost._id) {
            result = await requestPostManager.update(this, this.requestPost)
          // 新規（あり得ないが念のため）
          } else {
            result = await requestPostManager.register(this, this.requestPost)
            this.requestPost._id = result.id
            this.requestPost.requestNo = result.requestNo
          }

        // 参照画面（サブタスク）
        } else {
          if (this.requestPost.agent) {
            log = await dialogs.showConfirmDialog3('採否通知先を選択してください', '採否通知先はいかがしますか？', 'エージェントのみ', '新卒者のみ', '両方')
          } else {
            log = await dialogs.showConfirmDialog('新卒者へ採否メール送信しますか？', '今すぐ採否メールを送信してよろしいでしょうか？\r\nまた、送信前に今のデータを保存します。')
            if (log != 'YES') {
              return
            }
            log = '2'
          }
        }

        let msg = []
        if (this.requestPost.sentMail && log !== '1') {
          msg.push('新卒者')
        }
        if (this.requestPost.sentAgent && log !== '2') {
          msg.push('エージェント')
        }
        if (msg.length) {
          const check = await dialogs.showWarningConfirmDialog(msg.join('・') + 'へすでに送信済み', 'システム上ではすでに送信した記録がありますが、再度送信してよろしいでしょうか？')
          if (check !== 'YES') {
            return
          }
        }


        // 添付が重いと遅いので、必要なものだけ
        const param = {
          _id: this.requestPost._id,
          requestNo: this.requestPost.requestNo,
          newGrad: this.requestPost.newGrad,
          interviewer: this.requestPost.interviewer,
          interviewerId: this.requestPost.interviewerId,
          interviewsMail: this.requestPost.interviewsMail,
          interviewsName: this.requestPost.interviewsName,
          mailDomain: this.requestPost.mailDomain,
          mailSubject: this.requestPost.mailSubject,
          mailText: this.requestPost.mailText,
          interviewsResult: this.requestPost.interviewsResult,
          toStaffName: this.requestPost.toStaffName,
          toStaffId: this.requestPost.toStaffId,
          agent: this.requestPost.agent,
          sentMailUser: utils.deleteKana(this.$store.getters.user.user_name),
          sendTo: log, // 1：エージェントのみ、2：新卒のみ、3：両方
          agentList: this.agentList
        }

        const res = await backend.postData('cron/interviewsResSendMailNewGrad', param)
        const result = res.data.data

        // エージェント通知のみ
        if (log === '1') {
          if (result.agentRes === 'success') {
            await dialogs.showSuccessDialog('送信完了', 'エージェントに送信しました。画面をリロードします。')
            this.waiting = true
            this.$router.go(0)
          } else {
            await dialogs.showErrorDialog('送信失敗', result.agentRes)
          }

        // 新卒のみ、両方（エージェントはできれば送って、程度なのでエラーでも表示しない）
        } else {
          if (result.res === 'success') {
            await dialogs.showSuccessDialog('送信完了', 'また、「連絡」に関するサブを1つ完了しました。画面をリロードします。')
            this.waiting = true
            this.$router.go(0)
          } else {
            let err =  'エラー詳細：' + result.res

            await dialogs.showErrorDialog('送信失敗', err)

            if (err.indexOf('パスワード') > -1) {
              this.mailPassErr = true
            }
          }
        }
        this.reload++
      },

      /**
       * 合否通知メールをセット
       */
      setMail() {
        if (this.requestPost.interviewsResult && this.requestPost.interviewsResult.length) {
          if (this.requestPost.interviewsResult[0] === '社員採用') {
            this.requestPost.mailSubject = '【アポロ管財】面接結果のご連絡'
            this.requestPost.mailText = this.mailPassedText()
          } else if (this.requestPost.interviewsResult[0] === '社員不採用') {
            this.requestPost.mailSubject = '【アポロ管財】選考結果のご連絡'
            this.requestPost.mailText = this.mailFailedText()
          }
        } else {
            this.requestPost.mailSubject = ''
            this.requestPost.mailText = ''
        }
        this.reload++
      },

      /**
       * 合格通知文
       */
      mailPassedText() {
        let t = `${this.requestPost.interviewsName}`
        if (t) t += ' 様\r\n\r\n'
        t += 'この度はお忙しい中、当社の一次面接ならびに適性検査を受けていただき、誠にありがとうございました。\r\n'
        t += '選考の結果、次の選考へお進みいただくこととなりましたのでご連絡いたします。\r\n\r\n'
        t += 'つきましては、社長面接の日程調整のため、改めてご連絡させていただきます。\r\n'
        t += '今後ともよろしくお願いいたします。\r\n\r\n'

        t += 'アポロ管財株式会社\r\n'
        t += (this.requestPost.interviewer || '')
        return t
      },

      /**
       * 不合格通知文
       */
      mailFailedText() {
        let name = ''
        if (this.requestPost.interviewsName) {
          name = this.requestPost.interviewsName + ' 様'
        }
        let t = name + '\r\n\r\n'
        t += 'この度はお忙しい中、当社の一次面接にご参加いただきありがとうございました。\r\n'
        t += '慎重に選考を行いました結果、誠に残念ではございますが、今回はご希望に沿いかねる結果となりました。\r\n\r\n'
        t += 'せっかくご応募いただいたにもかかわらず、このような結果となりましたことを心よりお詫び申し上げます。\r\n'
        t += (name ? name + 'の' : '')
        t += '今後のご活躍を心よりお祈り申し上げます。\r\n\r\n'

        t += 'アポロ管財株式会社\r\n'
        t += (this.requestPost.interviewer || '')
        return t
      },

      /**
       * 辞退理由反映
       */
      saveReason(e) {
        if (e) {
          this.requestPost.declineReason = e
        }
        // メイン
        if (this.from === 'main') {
          this.$router.push({ name: 'RequestPostList' })

        // サブ
        } else if (this.from === 'sub') {
          this.$router.push({ name: 'RequestPostProgressList' })
        } else {
          this.$router.push({ name: 'RequestPostList' })
        }
      },

      /**
       * エージェント取得
       * ※送信時にルームＩＤは取得する
       */
      async getAgentList() {
        const res = await backend.searchData('chatworkData/getByType', { type: 3 })
        if (res.data.data) {
          this.agentList = res.data.data
        }
      },

      /**
       * メール変更
       */
      async changeMail() {
        if (this.requestPost.interviewsMail && this.requestPost.interviewsResult && this.requestPost.interviewsResult.length && !this.requestPost.mailText) {
          const log = await dialogs.showWarningConfirmDialog('メール本文未設定', 'メール本文が設定されていません。設定しますか？')
          if (log == 'YES') {
            this.setMail()
          }
        }
      },
    }
  }
</script>

<style scoped>
  .five-selection >>> button[type=button] {
    width: 19.8% !important;
  }

  .send-date >>> input {
    text-align: center !important;
  }

  /* 入力欄を自動調整 */
  WmsTextInput >>> textarea {
    field-sizing: content !important;
  }

  textarea {
    field-sizing: content !important;
  }
</style>